var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('img',{style:({
			width: '200px',
			height: 'auto',
			marginTop: '25px',
			marginBottom: '15px',
			marginLeft: 'auto',
			marginRight: 'auto'
		}),attrs:{"src":require("@/assets/roundupapp_logo.png")}}),_c('p',{style:({ marginTop: '-5px', fontSize: '8px' })},[_vm._v("\n\t\t© 2017-2021 Flourish Change Inc. All Rights Reserved\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }